// @flow
import React from 'react';
import classNames from 'classnames';
import './LoadingPlaceholder.less';

type Props = {
    extraClasses: string,
    rounded?: ?boolean
};

const LoadingPlaceholder = ({extraClasses, rounded}: Props) => {
    return (
        <div className={`LoadingPlaceholder ${extraClasses}`}>
            <div
                className={classNames(
                    'LoadingPlaceholder__inner',
                    rounded && 'Rounded'
                )}
            />
        </div>
    );
};

export default LoadingPlaceholder;
